module.exports = __webpack_public_path__ + "static/img/act-steps-m-3.ff14ed1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-m-3.png
// module id = 3jkN
// module chunks = 1